import {
  type CodeBlockLowlightOptions,
  CodeBlockLowlight as TiptapCodeBlockLowlight,
} from '@tiptap/extension-code-block-lowlight';
import { common, createLowlight } from 'lowlight';

export const CodeBlockLowlight = TiptapCodeBlockLowlight.extend({
  addOptions(): CodeBlockLowlightOptions {
    const parent = (
      this as unknown as { parent?: () => CodeBlockLowlightOptions }
    ).parent;
    const parentOptions = (parent?.() ??
      {}) as Partial<CodeBlockLowlightOptions>;
    return {
      ...parentOptions,
      lowlight: createLowlight(common),
      defaultLanguage: null,
      languageClassPrefix: parentOptions.languageClassPrefix ?? 'language-',
      HTMLAttributes: {
        class: 'block-node',
      },
    } as CodeBlockLowlightOptions;
  },
});

export default CodeBlockLowlight;
